export default __webpack_public_path__ + "3b39914cf61a273cef2b5b4cc278c14a.png";